export default [
  {
    for: 'artist',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
    excludedProperties: ['text'],
  },
  {
    for: 'category',
    actions: {
      create: true,
      update: true,
      read: true,
    },
  },
  {
    for: 'live-event',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
    excludedProperties: [
      'seoTitle',
      'seoDescription',
      'seoImage',
      'ownedByChannel',
    ],
  },
  {
    for: 'live-partner',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
      unlockEntity: true,
      blockEntity: true,
    },
  },
  {
    for: 'link',
    actions: {
      create: true,
      update: true,
      read: true,
      delete: true,
    },
  },
];
